module.exports = __webpack_public_path__ + "img/new_index_cases9.94fa0b13.png";